import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
import { ROL_BASE_OBJ } from '@/constantes/roles.js'
import $ from 'jquery';
const db = firebase.firestore()

var cargadorCatalogosRoles = null;
var cargadorRol = null;

const store = {
  state: {
    rol:{},
    roles:{},
    rolHeader:{},
  },
  getters: {
    rol: state => {
      return state.rol;
    },
    rolHeader: state => {
      let objetoBase = JSON.parse(JSON.stringify(ROL_BASE_OBJ));
      const rolHeader = $.extend( true, objetoBase, state.rolHeader );
      return rolHeader;
    },
    roles: state => {
      return state.roles;
    },
  },
  mutations: {
    ASIGNA_ROL(state, data) {
      state.rol= data;
    },
    ASIGNA_ROL_HEADER(state, data) {
      state.rolHeader= data;
    },
    ASIGNA_ROLES(state, data) {
      state.roles= data;
    },
  },
  actions: {

    agregarRol({ dispatch, getters }, rol) {
      console.log('>>>>>getters.franquicia.id')
      console.log(getters.franquicia.id)
      return new Promise((resolve, reject) => {
        db.collection("Franquicias").doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.ROLES)
        .add(rol)

          resolve()
      })
    },

    actualizarRol({ dispatch, getters }, rol) {
       return new Promise((resolve, reject) => {
        db.collection("Franquicias").doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.ROLES)
           .doc(rol.id)
           .update(rol)

           resolve()
       })
     },


    eliminarRol({getters}, idRol) {
      return db.collection("Franquicias").doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.ROLES)
        .doc(idRol)
        .delete()
    },



    /**CARGAR ROL SELECCIONADO */
    cargarRol({ commit,getters }, idRol) {
      console.log('Store roles carga: ' + idRol)
      return new Promise((resolve, reject) => {
        let docPath = db.collection("Franquicias").doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.ROLES).doc(idRol);
        docPath.onSnapshot(doc => {
          commit('ASIGNA_ROL', doc.data())
          resolve(doc.data())
        })
      })
    },

    cargarRolHeader({ commit,getters }, idRol) {
      return new Promise((resolve, reject) => {
        if (cargadorRol === null) {
          let docPath = db.collection("Franquicias").doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.ROLES).doc(idRol);
          cargadorRol = docPath.onSnapshot(doc => {
            commit('ASIGNA_ROL_HEADER', doc.data())
            resolve(doc.data())
          })
        } else {
          resolve()
        }
      })
    },


    /** Cargar lista de roles para la tabla */
    cargaIndiceRoles({ commit, getters }) {
      return new Promise((resolve, reject) => {
        if (cargadorCatalogosRoles === null) {
          let docPath = db
            .collection(FS_COLLECTIONS.FRANQUICIAS)
            .doc(getters.franquicia.id)
            .collection(FS_COLLECTIONS.INDICES)
            .doc(FS_COLLECTIONS.ROLES)
          cargadorCatalogosRoles = docPath.onSnapshot(doc => {
            resolve()
            commit('ASIGNA_ROLES', doc.data())
          })
        } else {
          resolve()
        }
      })
    },
   
    

  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/roles/roles.js